import EventCardBadgeImpl from './event-card-badge.js';
import MojitoCore from 'mojito/core';

/**
 * Category badge shared by event cards. Labels a card with the promotion category it belongs to,
 * for example a featured match or a price boost. Renders nothing until a label or an icon is
 * configured, so cards carrying the badge stay unchanged until an operator opts in.
 *
 * @function EventCardBadge
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Badge
 */

export default MojitoCore.Presentation.UIView('EventCardBadge', EventCardBadgeImpl);
